import React from 'react';
import {withRouter} from 'react-router-dom';

import CAUIWrapper from "../common/CommonAuthUserInterfaceWrapper";
import "./WebSSO.scss";

export const WebSSO = () => {
  let contextDataToken = document.getElementById('token').value;
  let cloudEnv = document.getElementById('cloudEnv').value;
  let ssdmEnv = document.getElementById('ssdmEnv').value;
  let sendAuthToken = (authToken) => {
    let authTokenElement = document.getElementById('auth_token');
    authTokenElement.value = authToken;
    let authForm = document.getElementById('auth_form');
    authForm.submit();
  };
  return (
      <div className="app">
        <CAUIWrapper contextDataToken={contextDataToken}
                     cloudEnv={cloudEnv}
                     ssdmEnv={ssdmEnv}
                     product={"WebSSO"}
                     onAuthTokenReceived={sendAuthToken}/>
      </div>
  )
};

export default withRouter(WebSSO);
